{"loading":"読み込み中...","error":"エラーが発生しました","notFound":"見つかりません"}